<template>
	<div class="wrapper">
		<div class="wrappers">
			<!--左侧部分-->
			<div class="mn">
				<div class="swiper">
					<el-carousel :interval="4000" :autoplay="false" arrow="always" height="350px">
					    <el-carousel-item v-for="(item,i) in bokearr" v-if="i<5" :key="i" class="el-carousel-item" 
						style="
						background-size: cover;
						background-repeat: no-repeat;
						background-position: 50% 50%;
						background-color: rgba(120,120,120,0.1);
						"
						:style="{backgroundImage:'url('+ item.imgurl +')'}"
						>
					      <div class="zhezhao">
							  <div class="zhezhaosss" style="cursor: pointer;" @click="bokedetail(item.id)">
								  {{item.title}}
							  </div>
						  </div>
					    </el-carousel-item>
					  </el-carousel>
				</div>
				
				<div class="jinghua">
					<div class="jinghuas">
						<div class="jinghuas01">
							精彩博客
						</div>
						<div class="dxb_bc">
							<div class="dxb_bcs" v-for="(item,i) in bokearr" @click="bokedetail(item.id)" :key="i" v-if="i<4">
								<div class="zz_jspc_pfthpic">
									<img :src="item.imgurl" alt="">
								</div>
								<div class="zz_jspc_pfthtext">
									<div class="zz_jspc_pfthtext01">{{item.title}}</div>
									<div class="zuozhe">作者：{{item.nickname}}</div>
									<div class="zz_jspc_pfthtext02sss">
										博客
										<span class="span">阅读</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="luntan">
					<div class="luntans" style="position: relative;" v-for="(item,i) in tieziarr"  @click="tiezidetail(item)"  :key="i" v-if="i<5">
						<img v-if="item.jinghua==1" src="../../../assets/jinghua01.png" style="position: absolute;width: 30px;top: 20px;right: 20px;" alt="">
						
						
						<div class="luntanss">
							<div class="luntan01" :style="{width: item.imgurl?'600px':''}">
								<div class="l01">{{item.title}}</div>
								<div class="l02" v-html="item.content">
									
								</div>
								<div class="l03">
									<img :src="item.headimgurl" class="l03img"  alt="">
									<div class="zz_post_tname">{{item.nickname}}</div>
									<div class="zz_post_time">{{item.createTime}}</div>
									<div class="zz_item_info zz_item_info_v">{{item.show}}</div>
									<div class="zz_item_info zz_item_info_r">{{item.pingnum}}</div>
									<div class="zz_post_flink">
										# {{item.zhutiName}} #
									</div>
								</div>
							</div>
							<div class="luntan02" v-if="item.imgurl"
							style="
							background-size: cover;
							background-repeat: no-repeat;
							background-position: 50% 50%;
							background-color: rgba(120,120,120,0.1);
							"
							:style="{backgroundImage:'url('+ item.imgurl +')'}"
							>
								
							</div>
						</div>
					</div>
					<div class="zhanzhuai-loading">
						亲，已经到底了
					</div>
				</div>
			</div>
			<!--左侧部分-->
			<!--右侧部分-->
			<div class="ri" style="overflow: visible;box-sizing: border-box;">
				<div class="zz_jspc_pdiy">
					<div class="zhanzhuai_board">
						<div class="zhanzhuai_boards" @click="newthread('/newthread',1,'最新发表')" style="margin-top: -4px;">
							<img src="../../../assets/b1.png" alt="">
						</div>
						<div class="zhanzhuai_boards" @click="newthread('/newthread',2,'最新评论')" >
							<img src="../../../assets/b2.png" alt="">
						</div>
						<div class="zhanzhuai_boards" @click="newthread('/newthread',3,'社区精华')" >
							<img src="../../../assets/b3.png" alt="">
						</div>
						<div class="zhanzhuai_boards" @click="newthread('/newthread',4,'我的帖子')" >
							<img src="../../../assets/b4.png" alt="">
						</div>
						<div class="zhanzhuai_boards" @click="newthread('/newthread',5,'抢沙发')" >
							<img src="../../../assets/b5.png" alt="">
						</div>
					</div>
				</div>
				
				<!--推荐会员-->
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						推荐会员
					</div>
					<div style="position: relative;"  class="zz_hyli1" v-for="(item,i) in userarr" :key="i">
						<div class="zz_hylist_avt" @click="taboke(item.uid)">
							<img v-if="item.headimgurl" :src="item.headimgurl" alt="">
						    <img v-else src="../../../assets/132.png" alt="">
						</div>
						<div class="zz_hylist_text">
							<div class="zz_hylist_name">{{item.nickname}}</div>
							<div class="zz_hylist_count">博客<span>{{item.bokenum}}</span></div>
						</div>
						<el-button @click="user_guanzhu(item.uid)" :type="item.guanzhu==true?'danger':'primary'" size="mini" style="position: absolute;right:0px;">
							{{item.guanzhu==true?'取消关注':'关注'}}
						</el-button>
					</div>
				</div>
				<!--推荐会员-->
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						推荐阅读
					</div>
					<div class="yueduo">
						<div class="yueduos"  v-for="(item,i) in bokearr" @click="bokedetail(item.id)" v-if="i<7" :key="i">
							<i></i>
							<div class="yueduos01">
								<div class="zz_recnews_title">{{item.title}}</div>
								<div class="zz_recnews_time">{{item.createTime}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						友情链接
					</div>
					<div class="friend_links">
						<a href="https://www.eframesoft.cn/" target="_blank">领驭框架(北京)软件有限公司</a>
					</div>
				</div>
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						关注我们
					</div>
					<div class="focusus-img">
						<img src="../../../assets/weibo.png" alt="">
						<img src="../../../assets/weixin.png" style="margin-right: 0px;" alt="">
					</div>
				</div>
			</div>
			<!--右侧部分-->
		</div>
	</div>
</template>

<script>
	import { user_boke_list,tiezi_list } from "@/api/boke"
	import { tuijian_user_list,user_guanzhu } from "@/api/user"
		import { getToken } from '@/utils/auth'
	export default {
		data(){
			return{
				bokearr:[],//博客数组
				tieziarr:[],//帖子列表
				userarr:[],//推荐会员列表
			}
		},
		mounted(){
			document.title = "MetaBiz";
			this.user_boke_list();//博客列表
		},
		methods:{
			taboke(uid){
				window.location.href = "/#/taboke?uid=" + uid
			},
			user_guanzhu(uid){
				if(getToken()){
					 const loading = this.$loading({
						  lock: true,
						  text: '操作中',
						  spinner: 'el-icon-loading',
						  background: 'rgba(0, 0, 0, 0.7)'
						});
					user_guanzhu({
						uid:uid
					}).then(()=>{
						loading.close();
						this.$message.success("成功");
						this.tuijian_user_list();
					}).catch(()=>{
						loading.close();
					})
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			tiezidetail(row){
				this.$router.push({
					path:'/forumdetail',
					query:{
						id:row.id
					}
				})
			},
			bokedetail(id){
				this.$router.push({
					path:'/bokedetail',
					query:{
						id:id
					}
				})
			},
			tuijian_user_list(){
				tuijian_user_list({
					page:1,
					limit:4
				}).then(res=>{
					console.log("会员列表",res.data);
					this.userarr = res.data.list
				}).catch(()=>{
					
				})
			},
			async user_boke_list(){
				await user_boke_list({
					page:1,
					limit:12,
					imgurl:true
				}).then(res=>{
					console.log("博客列表",res.data);
					this.bokearr = res.data.list
				}).catch(()=>{
					
				})
				await tiezi_list({
					page:1,
					limit:12
				}).then(res=>{
					console.log("帖子列表",res.data);
					this.tieziarr = res.data.list
				}).catch(()=>{
					
				})
				await tuijian_user_list({
					page:1,
					limit:4
				}).then(res=>{
					console.log("会员列表",res.data);
					this.userarr = res.data.list
				}).catch(()=>{
					
				})
			},
			newthread(path,type,title){
				if(type==4){
					if(getToken()){
						this.$router.push({
							path:path,
							query:{
								type:type
							}
						})	
					}else{
						loginEvent.$emit('loginDialogEvent')
					}
				}else{
				this.$router.push({
					path:path,
					query:{
						type:type
					}
				})	
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.luntan02{
		    width: 192px;
		    height: 135px;
			margin-left: auto;
	}
	.zz_jspc_pdiy{
		margin-bottom: 15px;
		.focusus-img{
			height: 130px;
			img{
				float: left;
				    width: 106px;
				    height: 106px;
				    margin-right: 18px;
				    padding: 10px;
				    background: #f7f9fa;
				    border: 1px solid #f5f6f7;
					object-fit: cover;
			}
		}
		.friend_links{
			cursor: pointer;
			a{
			  line-height: 1.4;
			      font-size: 13px;
			      color: #333;
				  text-decoration: none;
			}
			a:hover{
				color: #FFA07A;
			}
		}
		.yueduo{
			// height: 390px;
			border-left: 1px solid #EEEEEE;
			.yueduos{
				position: relative;
                padding: 6px 0 6px 15px;
				cursor: pointer;
				.yueduos01{
					line-height: 24px;
					color: #999;
					.zz_recnews_title{
						font-size: 14px;
						color: #333;
						overflow: hidden;
					}
					.zz_recnews_title:hover{
						color: #FFA07A;
					}
					.zz_recnews_time{
						margin-bottom: 10px;
						font-size: 14px;
						font-style: inherit;
						font-family: Georgia;
					}
				}
				i{
				    width: 5px;
				    height: 5px;
				    background: #fff;
				    border-width: 1px;
				    border-color: #aaa;
				    border-style: solid;
				    border-radius: 100%;
				    position: absolute;
				    z-index: 1;
				    left: -4px;
				    top: 15px;	
				}
			}
			.yueduos:hover{
				i{
					background: #FFA07A;
					border-color: #FFA07A;
				}
			}
		}
		.zz_hyli1:last-child{
			margin-bottom: 0px;
		}
		.zz_hyli1{
			margin-bottom: 30px;
			display: flex;
			align-items: center;
			cursor: pointer;
			.zz_hylist_text{
				height: 50px;
				display: flex;
				justify-content: center;
				flex-direction: column;
				.zz_hylist_name{
					font-size: 14px;
				}
				.zz_hylist_name:hover{
					color: #FFA07A;
				}
				.zz_hylist_count{
					margin-top: 5px;
					font-size: 12px;
					color: #969696;
					display: flex;
					span{
						margin-left: 10px;
					}
				}
			}
			.zz_hylist_avt{
				width: 50px;
				height: 50px;
				margin-right: 15px;
				overflow: hidden;
				img{
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
		}
		.zhanzhuai_board{
			width: 325px;
			.zhanzhuai_boards{
				display: block;
				    height: 53px;
				    margin-bottom: 9px;
				    border-radius: 4px;
				    cursor: pointer;
				    overflow: hidden;
					img{
						width: 100%;
						    height: auto;
						    border-radius: 4px;
							border: none;
					}
			}
		}
	}
	.zhanzhuai-loading{
		padding: 25px;
		    font-size: 14px;
		    color: #999;
		    text-align: center;
	}
	.luntan{
		width: 100%;
		background: #fff;
		border-radius: 4px;
		transition:all .6s ease;
		margin-bottom: 15px;
		cursor: pointer;
		.luntan01{
			.zz_post_flink{
				margin-left: auto;
				height: 25px;
				line-height: 25px;
				font-size: 12px;
				color: #FFA07A;
			}
			.zz_item_info_v{
				float: left;
				margin-left: 25px;
				background: url("../../../assets/p_views.png") no-repeat 0 5px;
			}
			.zz_item_info_r{
				float: left;
				background: url("../../../assets/p_replys.png") no-repeat 0 6px;
			}
			.zz_item_info{
				margin-right: 15px;
				height: 25px;
				line-height: 25px;
				    padding: 0 10px 0 21px;
				    font-size: 12px;
				    color: #748594;
				    display: inline-block !important;
			}
			.l03{
				display: flex;
				align-items: center;
				height: 25px;
				margin-top: 15px;
				.zz_post_time{
					color: #748594;
					font-size: 12px;
					margin-left: 10px;
				}
				.zz_post_tname{
					color: #48494d;
					font-size: 14px;
				}
				.l03img{
					width: 25px;
					height: 25px;
					border-radius: 50%;
					margin-right: 8px;
				}
			}
			.l01{
				margin-bottom: 10px;
				font-size: 18px;
				color: #262626;
				font-weight: 700;
			}
			.l01:hover{
			    color: #FFA07A;
			}
			.l02{
				line-height: 22px;
				margin-bottom: 15px;
				font-size: 14px;
				color: #787878;
				display:-webkit-box;         //将对象作为弹性伸缩盒子模型显示。
						-webkit-box-orient:vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
						-webkit-line-clamp:2;        //限制行数
						overflow:hidden;             //超出部分隐藏
						text-overflow:ellipsis;      //用一个省略号代替超出的内容
			}
		}
		.luntans{
			width: 100%;
			border-bottom: 1px solid #f0f0f0;
			.luntanss{
				width: 810px;
				margin: 0 auto;
				padding: 25px;
				display: flex;
				
			}
		}
	}
	.jinghua{
		width: 100%;
		background: #fff;
		border-radius: 4px;
		transition:all .6s ease;
		margin-bottom: 15px;
		.jinghuas{
			width: 810px;
			margin: 0 auto;
			.dxb_bc{
				width: 100%;
				height: 240px;
				padding-top: 20px;
				padding-bottom: 20px;
				display: flex;
				flex-wrap: wrap;
				.dxb_bcs{
					width: 385px;
					height: 110px;
					margin: 0 20px 20px 0;
					overflow: hidden;
					cursor: pointer;
					.zz_jspc_pfthtext{
						position: relative;
						.zz_jspc_pfthtext02sss{
							display: flex;
							align-items: center;
							font-size: 13px;
							color: #787878;
							margin-top: 15px;
							.span{
								margin-left: auto;
								height: 20px;
								padding: 0 6px;
								font-size: 12px;
								color: #fff;
							   line-height: 20px;
							   border-radius: 2px;
								background: #fc7247;
							}
						}
						width: 250px;
						height: 100%;
						margin-left: auto;
						.zz_jspc_pfthtext01{
							width: 100%;
							word-wrap: break-word;
							color: #262626;
							font-size: 15px;
							font-weight: 400;
						}
						.zz_jspc_pfthtext01:hover{
							color: #fc7247;
						}
						.zuozhe{
							margin-top: 8px;
							font-size: 13px;
							color: #8590a6;
						}
					}
					.zz_jspc_pfthpic{
						float: left;
						width: 130px;
						height: 110px;
						margin-right: 15px;
						overflow: hidden;
						img{
							width: 100%;
							height: 100%;
						}
					}
				}
			}
			.jinghuas01{
				width: 100%;
				height: 50px;
				border-bottom: 1px solid #ececec;
				display: flex;
				align-items: center;
				color: #333;
				font-size: 20px;
			}
		}
	}
	/deep/ .el-carousel__indicators--horizontal {
		position: absolute;
		left: auto;
		right: 10px;
		bottom: 10px;
		text-align: right;
 
		.el-carousel__indicator--horizontal button {
			width: 8px;
			height: 8px;
			background: #ffffff;
			border-radius: 50%;
			opacity: 0.5;
		}
 
		.el-carousel__indicator--horizontal.is-active button {
			width: 24px;
			height: 8px;
			background: #fc7247;
			opacity: 0.5;
			border-radius: 10px;
		}
	}
	.swiper{
		width: 100%;
		margin: 0 auto;
		background: #fff;
		margin-bottom: 15px;
		overflow: hidden;
		.el-carousel-item{
			width: 100%;
			height: 100%;
            border-radius: 4px;
			position: absolute;
			.zhezhao{
				width: 100%;
				height: 60px;
				position: absolute;
				bottom: 0px;
				left: 0px;
				transition:opacity 0.3s ease-in-out;
				background: linear-gradient(to bottom,rgba(35,41,50,0.1),rgba(35,41,50,0.8));
				border: 0 0 4px 4px;
				.zhezhaosss{
					width: 680px;
					margin-left: 20px;
					height: 100%;
					display: flex;
					align-items: center;
					font-size: 17px;
					color: #fff;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					z-index: 10;
				}
			}
		}
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
			display: flex;
			.mn{
				width: 860px;
				margin-bottom: 10px;
			}
			.ri{
				width: 325px;
				margin-left: auto;
				margin-bottom: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/index/index.vue